var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPintar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 21,
    viewBox: "0 0 79 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0184 2.1H4.98283V17.325H74.0184V2.1Z",
    fill: "#EFEEEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8894 7.70159L68.7705 6.71932H66.061V10.4999H68.766L69.8891 9.51368L69.8894 7.70159Z",
    fill: "#A83021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0016 6.71906L52.7103 10.5001H55.4314L54.1412 6.71906H54.0016Z",
    fill: "#A83021"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0V21H78.5V0H0.5ZM11.5041 15.9622H6.23921V14.2836H7.67438V6.72094H6.23921V5.04037H10.0676V14.2836H11.5028L11.5041 15.9622ZM16.2909 10.0816L13.9055 12.1828H11.0261V10.5019H12.774L13.8982 9.51507V7.70367L12.7781 6.72094H11.0261V5.04037H13.8979V5.03669L13.9021 5.04037H13.9092L16.2904 7.13643L16.2909 10.0816ZM22.5113 6.71887H21.0534V14.2807H22.5113V15.9622H17.2465V14.2816H18.6609V6.71887H17.2465V5.03829H22.5113V6.71887ZM36.3898 6.71887H34.9538V14.2807H36.3898V15.9622H32.5615V15.9486L27.7757 8.67584V14.2818H29.2111V15.9622H23.9462V14.2816H25.3821V6.71887H23.9462V5.03829H27.7749L32.5606 12.3108V6.71887H31.1249V5.03829H36.3895L36.3898 6.71887ZM44.0474 6.71887V14.2809H45.4828V15.9622H40.2182V14.282H41.6539V6.71887H39.7394V8.39945H37.8249V5.03853H47.8751V8.39945H45.9609V6.71887H44.0474ZM60.7967 15.9622H55.5321V14.2816H56.7221L56.0049 12.1809H52.1359L51.4186 14.2816H52.6604V15.9622H47.3955V14.2816H49.0254L51.6078 6.71979H50.2677V5.03921H57.9253V6.71887H56.533L59.1154 14.2807H60.7967V15.9622ZM72.7611 15.9622H69.8897V15.9548L67.4905 12.1814H66.061V14.2818H67.4967V15.9622H62.2321V14.2816H63.6678V6.71887H62.2321V5.03853H69.8894V5.03462L69.8939 5.03853H69.9007L72.282 7.13436V10.0791L69.8966 12.1802H69.8825L71.2184 14.2804H72.7608L72.7611 15.9622Z",
    fill: "#A83021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintar);
export default __webpack_public_path__ + "static/media/pintar.c8443cd5ab41befccdcec7cd7703a54d.svg";
export { ForwardRef as ReactComponent };